<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3acX8y/tc-custom/9781504006378.jpg?1737196287267" alt="This image is the cover for the book Depth Perception"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Depth Perception
      </h1>
      <p class="bookDescription body article font2">
        <b>This fourth book of poems from award-winning author Robin Morgan has an almost-novelistic shape, with plot twists that are realizations of self, other, and the nature of change</b><br/><br/> In this book of transitions, Robin Morgan’s poetry crosses the boundaries of age, race, culture, and gender. The lifelong love-hate passion between mother and daughter is here, as is a vivid, rhetoric-free depiction of the suffering and rage of women cross-culturally. Morgan also traces the slow dissolution of a marriage, parsed in poems of alternating hope and despair, humor and fury—and also in a tragicomic, two-character, one-act verse play, “The Duel: A Masque.” The play, which inverts the Orpheus-Eurydice myth, was performed at the Public Theater in New York City.<br/>  <br/> Praised by the literary world for her technique, but dedicated to keeping her craft accessible and impassioned, Morgan takes us through inevitable deaths and resurrections of the self in pitch-perfect language shot through with dazzling imagery and irony.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robin Morgan
      </h2>
      
      <p class="authorDescription body article">Award-winning poet, novelist, journalist, and feminist leader Robin Morgan has published more than twenty books, including the now-classic&#160;anthologies <I>Sisterhood Is Powerful</I>&#160;and&#160;<I>Sisterhood Is Global</I> and the bestselling&#160;<I>The Demon Lover: The Roots of Terrorism</I>.&#160;Her work has been translated into thirteen languages, among them Arabic, Chinese, Japanese, Korean, and Persian. A recipient of honors including a National Endowment for the Arts Creative Writing Fellowship, and former editor in chief of&#160;<I>Ms</I><I>.</I>, Morgan founded the&#160;Sisterhood Is Global Institute, and with Jane Fonda and Gloria Steinem, cofounded the Women&rsquo;s Media Center. She writes and hosts&#160;<I>Women&rsquo;s Media Center Live with Robin Morgan</I>,&#160;a weekly program with a global audience on&#160;iTunes&#160;and&#160;WMCLive.com&mdash;her commentaries legendary, her guests ranging from grassroots activists to Christiane Amanpour, Anita Hill, and President Jimmy Carter.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5497be7e